import React from 'react';
import Spinner from 'static/script/libs/spin';

export default class JsxSpinner extends React.Component {
    componentDidMount() {
        const { config } = this.props;
        const spinjsConfig = {
            width: 2,
            length: 4,
            radius: 5,
            lines: 11,
            color: '#404a54',
            ...config // overwrite default
        };

        this.spinner = new Spinner(spinjsConfig);
        this.spinner.spin(this.spinnerEl);
    }

    componentWillUnmount() {
        this.spinner.stop();
    }

    render() {
        const { className } = this.props;
        return <span className={className ? className : ''} ref={el => { this.spinnerEl = el; }} />;
    }
}


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/spinner/spinner.jsx